import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import { isReportIssuer } from '../../api/auth'
import { formatNumber, getOperatorLogoSrc } from '../../utils/utils'
import Loading from '../Loading'
import _ from 'lodash'

export default class BigNumbers extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isExplorer: this.props.isExplorer,
      isReport: this.props.report ? true : false,
      isPrint: this.props.isPrint,
      report: this.props.report,
      records: this.props.report ? this.props.report.readings : this.props.records,
      values: undefined,
      showSubOperators: this.props.report ? this.props.report.isReportGroup : isReportIssuer(),
      operatorName: this.props.report ? this.props.report.operatorName || 'IP' : this.props.operatorName || 'IP',
    }
  }

  componentDidMount() {
    if (this.state.records && this.state.records.length > 0) this.computeValues()
  }

  // componentDidUpdate() {
  //   console.log('?')
  //   this.setState(
  //     {
  //       isReport: this.props.report ? true : false,
  //       isPrint: this.props.isPrint,
  //       report: this.props.report,
  //       records: this.props.report ? this.props.report.records : this.props.records,
  //     },
  //     () => this.computeValues()
  //   )
  // }

  computeValues = () => {
    if (!this.state.records) return

    const state = this.state

    // Values are aggregated based on the incoming records.
    // In case of reports, addition variation values are included

    // Reports already contain the big numbers, and also include last month's and last year's variation
    // Frontpage numbers are passed as a report, but without variations
    // Otherwise, we need to calculate these values based on the passed records
    // and we don't show the variation from previous periods

    let consumptionTotal = state.records.map((d) => d.consumptionTotal).reduce((a, b) => a + b)
    let brakingTotal = state.records.map((d) => d.brakingTotal).reduce((a, b) => a + b)
    let kmTraveled = state.records.map((d) => d.kmTraveled).reduce((a, b) => a + b)

    let values = {
      consumptionTotal: consumptionTotal,
      consumptionVazio: state.records.map((d) => d.consumptionVazio).reduce((a, b) => a + b),
      consumptionSuperVazio: state.records.map((d) => d.consumptionSuperVazio).reduce((a, b) => a + b),
      consumptionPontas: state.records.map((d) => d.consumptionPontas).reduce((a, b) => a + b),
      consumptionCheias: state.records.map((d) => d.consumptionCheias).reduce((a, b) => a + b),
      brakingTotal: brakingTotal,
      brakingVazio: state.records.map((d) => d.brakingVazio).reduce((a, b) => a + b),
      brakingSuperVazio: state.records.map((d) => d.brakingSuperVazio).reduce((a, b) => a + b),
      brakingPontas: state.records.map((d) => d.brakingPontas).reduce((a, b) => a + b),
      brakingCheias: state.records.map((d) => d.brakingCheias).reduce((a, b) => a + b),
      consumptionGross: state.records.map((d) => d.consumptionGross).reduce((a, b) => a + b),
      kmTraveled: kmTraveled,
      consumptionKm: consumptionTotal / kmTraveled,
      brakingKm: brakingTotal / kmTraveled,
    }

    if (state.report) {
      values['consumptionVar'] = state.report.consumptionVar
      values['brakingVar'] = state.report.brakingVar
      values['kmTraveledVar'] = state.report.kmTraveledVar
      values['consumptionKmVar'] = state.report.consumptionKmVar
      values['brakingKmVar'] = state.report.brakingKmVar
    }

    if (!state.isRport && state.showSubOperators && !state.isExplorer) {
      // Calculate operator values from data
      let opvals = []

      let operators = _.uniqBy(state.records, 'operatorName').map((d) => d.operatorName)

      for (const op of operators) {
        const filteredByOp = state.records.filter((r) => r.operatorName === op)

        let consumptionTotal = filteredByOp.map((d) => d.consumptionTotal).reduce((a, b) => a + b)
        let brakingTotal = filteredByOp.map((d) => d.brakingTotal).reduce((a, b) => a + b)
        let kmTraveled = filteredByOp.map((d) => d.kmTraveled).reduce((a, b) => a + b)

        opvals.push({
          operatorName: op,
          consumptionTotal: consumptionTotal,
          consumptionKm: consumptionTotal / kmTraveled,
          consumptionVazio: filteredByOp.map((d) => d.consumptionVazio).reduce((a, b) => a + b),
          consumptionSuperVazio: filteredByOp.map((d) => d.consumptionSuperVazio).reduce((a, b) => a + b),
          consumptionPontas: filteredByOp.map((d) => d.consumptionPontas).reduce((a, b) => a + b),
          consumptionCheias: filteredByOp.map((d) => d.consumptionCheias).reduce((a, b) => a + b),
          brakingTotal: brakingTotal,
          brakingKm: brakingTotal / kmTraveled,
          brakingVazio: filteredByOp.map((d) => d.brakingVazio).reduce((a, b) => a + b),
          brakingSuperVazio: filteredByOp.map((d) => d.brakingSuperVazio).reduce((a, b) => a + b),
          brakingPontas: filteredByOp.map((d) => d.brakingPontas).reduce((a, b) => a + b),
          brakingCheias: filteredByOp.map((d) => d.brakingCheias).reduce((a, b) => a + b),
        })
      }

      values['operatorValues'] = opvals
    }

    this.setState({
      values: values,
    })
  }

  render() {
    if (!this.state.values) {
      return <Loading />
    }

    const state = this.state

    if (!this.state.records) return <div className="has-text-danger">No records do display.</div>

    const renderVariation = (varValue, positiveIsGood = false) => {
      if (!varValue) {
        return <></>
      }

      let positiveColor = positiveIsGood ? 'has-text-success' : 'has-text-danger'
      let negativeColor = positiveIsGood ? 'has-text-danger' : 'has-text-success'

      return (
        <span data-tooltip={'Face ao mês anterior'}>
          <span className={`${varValue >= 0 ? positiveColor : negativeColor} is-size-7 has-text-weight-light`}>
            &nbsp;
            <FontAwesomeIcon icon={varValue >= 0 ? 'caret-up' : 'caret-down'}></FontAwesomeIcon>
            &nbsp;
            {formatNumber(varValue * 100)} %
          </span>
        </span>
      )
    }

    // If it's a report group, bottom borders are 90º, else all borders have radius

    // When it's a report and a report group we show data for each operator,
    // otherwise, only a block of numbers is shown

    const renderFourEnergyValuesLine = (
      title,
      total,
      pkm,
      vazio,
      supervazio,
      pontas,
      cheias,
      totalVariation,
      posGood = false
    ) => {
      return (
        <div className="columns is-centered is-vcentered mb-0 mt-2">
          <div className="column has-text-centered">
            <p className="title is-size-6">{title} (kWh)</p>
          </div>

          <div className="column has-text-centered is-2">
            <p className="title is-size-6">
              {formatNumber(total, 0)} {totalVariation && renderVariation(totalVariation, posGood)}
            </p>
          </div>

          <div
            style={{
              borderLeft: '2px solid #bbb',
              height: '30px',
            }}
          />

          <div className="column has-text-centered">
            <p className="subtitle is-size-6">{formatNumber(vazio, 0)}</p>
          </div>

          <div className="column has-text-centered">
            <p className="subtitle is-size-6">{formatNumber(supervazio, 0)}</p>
          </div>

          <div className="column has-text-centered">
            <p className="subtitle is-size-6">{formatNumber(pontas, 0)}</p>
          </div>

          <div className="column has-text-centered">
            <p className="subtitle is-size-6">{formatNumber(cheias, 0)}</p>
          </div>

          <div
            style={{
              borderLeft: '2px solid #bbb',
              height: '30px',
            }}
          />

          <div className="column has-text-centered">
            <p className="subtitle is-size-6">{formatNumber(pkm, 3)}</p>
          </div>
        </div>
      )
    }

    // Main big numbers block
    const renderMainBigNumbers = () => {
      return (
        <div className="columns mx-0 px-0 is-centered is-vcentered">
          {/* LOGO */}

          {!this.state.isExplorer && (
            <div className="column is-2 has-text-centered">
              <img src={getOperatorLogoSrc(state.operatorName)} style={{ width: '80%' }} />
            </div>
          )}

          {/* NUMBERS */}
          <div className="column is-10 py-2">
            {/* HEADERS */}
            <div className="columns is-centered is-vcentered mb-0">
              <div className="column has-text-centered"></div>

              <div className="column has-text-centered is-2">
                <p className="subtitle is-size-6 has-text-weight-bold">Total</p>
              </div>

              <div className="column has-text-centered">
                <p className="subtitle is-size-6">Vazio</p>
              </div>

              <div className="column has-text-centered">
                <p className="subtitle is-size-6">Super Vazio</p>
              </div>

              <div className="column has-text-centered">
                <p className="subtitle is-size-6">Pontas</p>
              </div>

              <div className="column has-text-centered">
                <p className="subtitle is-size-6">Cheias</p>
              </div>

              <div className="column has-text-centered">
                <p className="subtitle is-size-6 has-text-weight-bold"> p/ km</p>
              </div>
            </div>

            {/* <hr style={{ borderTop: '2px solid #bbb', margin: '0px' }} /> */}

            {/* CONSUMO */}
            {renderFourEnergyValuesLine(
              'Consumo',
              state.values.consumptionTotal,
              state.values.consumptionKm,
              state.values.consumptionVazio,
              state.values.consumptionSuperVazio,
              state.values.consumptionPontas,
              state.values.consumptionCheias,
              state.values.consumptionVar,
              false
            )}

            <hr style={{ borderTop: '2px solid #bbb', margin: '0px' }} />

            {/* FRENAGEM */}
            {renderFourEnergyValuesLine(
              'Frenagem',
              state.values.brakingTotal,
              state.values.brakingKm,
              state.values.brakingVazio,
              state.values.brakingSuperVazio,
              state.values.brakingPontas,
              state.values.brakingCheias,
              state.values.brakingVar,
              true
            )}

            {/* P/ KM */}
          </div>
        </div>
      )
    }

    const operatorBigNumbers = (op) => {
      let oprep
      if (this.state.isReport) {
        oprep = this.props.report.reports.find((r) => r.operatorName === op)
      } else {
        oprep = this.state.values.operatorValues.find((r) => r.operatorName === op)
      }

      return (
        <div className="columns is-centered is-vcentered my-0">
          <div className="column is-2 has-text-centered">
            <img src={getOperatorLogoSrc(oprep.operatorName)} style={{ width: '60%' }} />
          </div>

          <div className="column is-10 has-text-centered">
            {renderFourEnergyValuesLine(
              'Consumo',
              oprep.consumptionTotal,
              oprep.consumptionKm,
              oprep.consumptionVazio,
              oprep.consumptionSuperVazio,
              oprep.consumptionPontas,
              oprep.consumptionCheias,
              oprep.consumptionVar,
              false
            )}

            <hr style={{ borderTop: '2px solid #bbb', margin: '0px' }} />

            {/* FRENAGEM */}
            {renderFourEnergyValuesLine(
              'Frenagem',
              oprep.brakingTotal,
              oprep.brakingKm,
              oprep.brakingVazio,
              oprep.brakingSuperVazio,
              oprep.brakingPontas,
              oprep.brakingCheias,
              oprep.brakingVar,
              true
            )}
          </div>
        </div>
      )
    }

    const renderSubReportNumbers = () => {
      const components = []

      if (this.state.report) {
        this.state.report.reports.forEach((r, ix) =>
          components.push(
            <div key={ix}>
              {operatorBigNumbers(r.operatorName)}
              {ix < this.state.report.reports.length - 1 && (
                <p
                  style={{
                    backgroundColor: this.props.isPrint ? 'white' : 'lightgray',
                    width: '100%',
                    height: '1px',
                    margin: '0px',
                  }}
                />
              )}
            </div>
          )
        )
      } else {
        this.state.values.operatorValues.forEach((r, ix) => {
          components.push(
            <div key={ix}>
              {operatorBigNumbers(r.operatorName)}
              {ix < this.state.values.operatorValues.length - 1 && (
                <p
                  style={{
                    backgroundColor: this.props.isPrint ? 'white' : 'lightgray',
                    width: '100%',
                    height: '1px',
                    margin: '0px',
                  }}
                />
              )}
            </div>
          )
        })
      }

      return components
    }

    const borders = state.isReport && state.report.isReportGroup ? '0px 0px 0px 0px' : '0px 0px 25px 25px'

    return (
      <>
        <div className="mx-5" style={{ backgroundColor: '#000028', borderRadius: '15px 15px 0 0', height: '50px' }}>
          <p className="subtitle ml-5 pt-2" style={{ color: 'white' }}>
            {this.props.title || 'Resumo'}
          </p>
        </div>

        <div
          className="mx-5"
          style={{
            backgroundColor: '#e5e5e9',
            borderRadius: borders,
          }}
        >
          {renderMainBigNumbers()}
        </div>

        {this.state.showSubOperators && !this.state.isExplorer && (
          <div
            className="mx-5"
            style={{
              backgroundColor: this.props.isPrint ? '#f2f2f7' : 'white',
              borderRadius: '0 0 25px 25px',
            }}
          >
            {renderSubReportNumbers()}
          </div>
        )}
      </>
    )
  }
}
